export class Building {
  static getPrettyName(building, withName = false) {
    return `${building.location.street_address_1}, ${building.location.city}, ${
      building.location.state
    } \
      ${building.location.zip}${
      withName && building.name !== null && building.name !== ''
        ? ` - ${building.name}`
        : ''
    }`;
  }
}



// WEBPACK FOOTER //
// ./src/domain/building.js